import { render, staticRenderFns } from "./BulkLinkedin.vue?vue&type=template&id=488e7f23&scoped=true"
import script from "./BulkLinkedin.vue?vue&type=script&lang=js"
export * from "./BulkLinkedin.vue?vue&type=script&lang=js"
import style0 from "./BulkLinkedin.vue?vue&type=style&index=0&id=488e7f23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e7f23",
  null
  
)

export default component.exports